// extracted by mini-css-extract-plugin
export default {"root":"IconInfo_root__gKKaP"};